
import React, { Component, useState } from 'react';
import {Route, BrowserRouter, Routes, Navigate} from "react-router-dom"
import FooterPage from './Components/FooterPage/FooterPage';
import HomePageView from "./Views/HomePageView";
import RequestView from "./Views/RequestView";
import SocialShareView from "./Views/SocialShareView";
import ContactView from "./Views/ContactView"
import UserLounge from './Components/UserLounge/UserLounge'
import StickyMenu3 from "./Components/StickyMenu3/StickyMenu3";
import ChatbotForm from './Components/ChatbotForm/ChatbotForm';
import DailyWorshipView from './Views/DailyWorshipView'
import AboutPageView from "./Views/AboutPageView";
import SubscribeView from "./Views/SubscribeView";
import ParticipationView from "./Views/ParticipationView";
import BiblePageView from "./Views/BiblePageView"
import PrivacyPageView from './Views/PrivacyPageView';
import "./Components/HomePage/HomePage.css";
import { globals, onClickAssistantHelper } from "./Components/Globals/Globals";
import LoginPageView from './Views/LoginPageView';
import ProtectedRoute from "./Components/ProtectedRoute/ProtectedRoute"
import UnProtectedRoute from "./Components/ProtectedRoute/UnProtectedRoute"
import About from './Components/Modal/About';
import Modal from './Components/Modal/Modal';
import { useSelector } from 'react-redux';

const App = (props) => {
  const [collapsed, setCollapsed] = useState(true);
  const [chatbot_help_collapsed, setChatbot_help_collapsed] = useState(globals.parameters.assistant_helper_collapsed);

  const { dialogModal, aboutModal} = useSelector((store) => store.modal);
  const { user} = useSelector((store) => store.auth);
  let allModalClosed = true;

  const toggleNavbar = () => setCollapsed(!collapsed);

  return (
    <BrowserRouter>
      {aboutModal.isOpen && <About/>}
      {dialogModal.isOpen && <Modal/>}
      

      {allModalClosed && <>
        <div id="menu">
            <StickyMenu3/>
        </div>
        
        {/* Router page content */}
        <div className="content">
        <Routes>
          <Route exact path = "/" element ={<HomePageView {...props}/>} />

          {/** Unprotected Routes */}
          <Route path = "/socialshare" element={<SocialShareView {...props}/>} />
          <Route path = "/dailyworship" element={<DailyWorshipView {...props}/>} />
          {/*<Route path = "/contact" element={<ContactView isAuthenticated={user?user.isAuthenticated:false}/>} />*/}
          <Route path = "/contact" element={<ContactView {...props}/>} />
          <Route path = "/about" element={<AboutPageView {...props}/>} />
          <Route path = "/subscription" element={<SubscribeView {...props}/>}/>
          <Route path = "/participation" element={<ParticipationView {...props}/>}/>
          <Route path = "/bibleread" element={<BiblePageView {...props}/>} />
          <Route path = "/privacy" element={<PrivacyPageView {...props}/>} />
          <Route path = "/login" element={<LoginPageView {...props}/>} />

          {/** Protected Routes */}
          <Route path = "/userlounge" element={<ProtectedRoute><UserLounge {...props}/></ProtectedRoute>} /> {/* Route with parameters */}
          <Route path = "/priere" element={<ProtectedRoute default="/login"><RequestView {...props}/></ProtectedRoute>} />

          <Route
              path="*"
              element={<Navigate to="/" replace />}
          />
        </Routes>
        </div>
        {user &&
        <ChatbotForm
          email={user.email}
          headerTitle="Assistant de requête"
          opened={false}
        />}
        {false && <div className={`help-assist ${chatbot_help_collapsed?"assist-close":""}`} onClick={(e)=>{onClickAssistantHelper(e)}}>Puis-je vous aider ?</div>}
      </>}
      {/* Footer */}
      <FooterPage/>
    </BrowserRouter>
  );
}

export default App;
